import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Colors, Web_url } from "../../common/Const";
import store from "../../redux/Store";
import Footer from "./Footer";
import Header from "./Header";

function ExclusiveFull() {
  const {state} = useLocation();
  console.log("state -->", state);
  const [windowSize, setWindowSize] = useState(0)
  const navigate = useNavigate()
  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const texts = [
    {
      id: 1,
      head: "Theni Kamadhenu Collections",
      para: "Loremipsum dolor sit amet, consectetur adipiscing elit. Curabitur quis elit bibendum, posuere velit nec, placerat magna. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla vulputate suscipit diam at congue. Aliquam sit amet elit lacus. Aliquam eget velit faucibus, lacinia tellus vitae, posuere felis. Vestibulum sit amet pulvinar ligula. Morbi ante lacus, tincidunt in purus non, fringilla ornare metus. Duis blandit urna non pretium maximus. Sed lacus arcu, convallis eu ex et, volutpat aliquet turpis.",
    },
    {
      id: 2,
      head: "Trend Inspired",
      para: "Loremipsum dolor sit amet, consectetur adipiscing elit. Curabitur quis elit bibendum, posuere velit nec, placerat magna. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla vulputate suscipit diam at congue. Aliquam sit amet elit lacus. Aliquam eget velit faucibus, lacinia tellus vitae, posuere felis. Vestibulum sit amet pulvinar ligula. Morbi ante lacus, tincidunt in purus non, fringilla ornare metus. Duis blandit urna non pretium maximus. Sed lacus arcu, convallis eu ex et, volutpat aliquet turpis.",
    },
    {
      id: 3,
      head: "List Collections",
      para: "Loremipsum dolor sit amet, consectetur adipiscing elit. Curabitur quis elit bibendum, posuere velit nec, placerat magna. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla vulputate suscipit diam at congue. Aliquam sit amet elit lacus. Aliquam eget velit faucibus, lacinia tellus vitae, posuere felis. Vestibulum sit amet pulvinar ligula. Morbi ante lacus, tincidunt in purus non, fringilla ornare metus. Duis blandit urna non pretium maximus. Sed lacus arcu, convallis eu ex et, volutpat aliquet turpis.",
    },
  ];
  const callFilter = (colId) => {
    console.log("calling filter -->>",colId)
    store.dispatch({ type: "setCollparams", payload: colId });
    navigate('/filter');
  }
  return (
    <div className="d-flex flex-column">
      <Header make={true} />
      <div style={{ backgroundColor: Colors.bg_color }}>
        <div className="container">
          <p className="mt-5 hd-ex-full" style={{color: Colors.Base_color}}>Exclusive</p>
          <span className="sm-text-exFul">
            Get ahead of the creative curve with customized categories tailored
            to your taste.
          </span>
          <div className="scrl-box-exFul">
            <div className={windowSize > 414 ? "row d-flex align-items-center justify-content-center gap-5" : "row d-flex align-items-center justify-content-center gap-3" } >
              {state && state.length > 0 && state.map((data) => {
                return (
                  <div
                    className="col-md-4 col-6 px-3 d-flex flex-column align-items-center justify-content-end p-0 exc-box excFul-box"
                    style={{
                        backgroundImage:
                          `url(${Web_url.Domain_url}` + `${data.image})`,
                      borderRadius: "30px",
                      height: "250px",
                    }}
                    role={"button"}
                    onClick={() => callFilter(data.id)}
                  >
                    <div
                      style={{
                        backgroundColor: "#8B4A44",
                        opacity: 0.7,
                        color: Colors.white_color,
                        borderRadius: "14px",
                      }}
                      className="d-flex align-items-center justify-content-center w-100 m-3 p-2"
                    >
                      <span className="d-flex flex-column align-items-center justify-content-center">
                        <b>{data.collection_name}</b>
                        <small
                          className="text-center mt-1"
                          style={{ fontSize: "12px", lineHeight: "1" }}
                        >
                          Gift for you special someone.
                        </small>
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="container mt-5">
            <div className=" collections-text pb-5">
              {texts.map((texts) => {
                return (
                  <div className="j-collections mb-5 ">
                    <h3
                      className="mb-4"
                      style={{ color: "#126a38", fontWeight: "50" }}
                    >
                      {texts.head}
                    </h3>
                    <p style={{fontFamily: 'AvenirLTStdMedium', color: 'gray', fontSize: '18px'}}>{texts.para}</p>
                  </div>
                );
              })}
            </div>
          </div>
      </div>

      <Footer />
    </div>
  );
}

export default ExclusiveFull;
